import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/orderserviceitemlist/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/orderserviceitemlist/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/orderserviceitemlist/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/orderserviceitemlist/save', params,options)

export const update = (params, options) =>
request.post('/api/orderserviceitemlist/update', params,options)
